// extracted by mini-css-extract-plugin
export default {"container":"loader_container__Pe076","lds":"loader_lds__5nXOJ"};